import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, body, action, icon }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-ink-300 px-6 py-12 text-center dark:border-ink-700">
      {icon && <div className="text-ink-400 dark:text-ink-500">{icon}</div>}
      <p className="font-display text-lg text-ink-800 dark:text-ink-100">{title}</p>
      {body && <p className="max-w-prose text-sm text-ink-600 dark:text-ink-400">{body}</p>}
      {action}
    </div>
  );
}
